import React from "react";
import { makeStyles } from "@material-ui/core";
import { color, motion } from "framer-motion";
import thailand from "../../../images/v4/country/common/icons/thailand.svg";
import canada from "../../../images/v4/country/common/icons/canada.svg";
import hongKong from "../../../images/v4/country/common/icons/hongKong.svg";
import india from "../../../images/v4/country/common/icons/india.svg";
import indonesia from "../../../images/v4/country/common/icons/indonesia.svg";
import malaysia from "../../../images/v4/country/common/icons/malaysia.svg";
import myanmar from "../../../images/v4/country/common/icons/myanmar.svg";
import philippines from "../../../images/v4/country/common/icons/philippines.svg";
import uk from "../../../images/v4/country/common/icons/uk.svg";
import us from "../../../images/v4/country/common/icons/us.svg";
import singapore from "../../../images/v4/country/common/icons/singapore.svg";
import Link from "../../v2/Link";

const useStyles = makeStyles((theme) => ({
  allCountry: {
    "& .centerContainer": {
      textAlign: "center",
    },
  },
  allCountries: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexWrap: "wrap",
    width: "100%",
    gap: "24px",
    rowGap: "24px",
    marginTop: "60px",
    "@media only screen and (max-width: 600px)": {
      rowGap: "15px",
      gap: "15px",
    },
  },
  country: {
    padding: "30px 20px",
    borderRadius: "16px",
    border: "1px solid #C0CFDD",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    width: "15%",
    gap: "12px",
    boxShadow: "none",
    cursor: "pointer",
    transition: "0.3s ease",
    "&:hover": {
      border: "1px solid #208EEC",
      boxShadow: "0px 0px 30px 0px rgba(32, 142, 236, 0.30)",
    },
    "@media only screen and (max-width: 600px)": {
      width: "47%",
    },
  },
}));

const AllCountries = () => {
  const countries = [
    {
      icon: singapore,
      link: "/country/best-crm-system-singapore-for-small-businesses",
      name: "Singapore",
    },
    {
      icon: malaysia,
      link: "/country/best-crm-software-in-malaysia/",
      name: "Malaysia",
    },
    {
      icon: india,
      link: "/country/best-crm-software-in-india/",
      name: "India",
    },
    {
      icon: myanmar,
      link: "/country/best-crm-software-in-myanmar/",
      name: "Myanmar",
    },
    {
      icon: philippines,
      link: "/country/best-crm-software-in-philippines/",
      name: "Philippines",
    },
    {
      icon: thailand,
      link: "/country/best-crm-software-in-thailand/",
      name: "Thailand",
    },
    {
      icon: indonesia,
      link: "/country/best-crm-software-in-indonesia/",
      name: "Indonesia",
    },
    {
      icon: canada,
      link: "/country/best-sales-crm-software-canada/",
      name: "Canada",
    },
    {
      icon: hongKong,
      link: "/country/best-crm-software-in-hong-kong",
      name: "Hong Kong",
    },
    {
      icon: us,
      link: "/country/best-crm-software-in-the-united-states/",
      name: "United States",
    },
    {
      icon: uk,
      link: "/country/best-crm-software-for-united-kingdom/",
      name: "United Kingdom",
    },
  ];

  const classes = useStyles();
  return (
    <section className={classes.allCountry}>
      <div className="container">
        <div className="centerContainer">
          <motion.h2
            initial={{ opacity: 1, y: 20 }}
            transition={{ duration: 0.3 }}
            whileInView={{ opacity: 1, y: 0 }}
            className="font-56 font-wix-semibold color-black1"
          >
            You may also like to visit
          </motion.h2>
        </div>
        <div className={classes.allCountries}>
          {countries.map((country, index) => (
            <Link to={country.link} className={classes.country}>
              <img alt={country.name} src={country.icon} />
              <p className="font-wix-medium font-18 color-black1">
                {country.name}
              </p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AllCountries;
